import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreditCardForm from '../../global/forms/creditCardForm';
import BankAccountForm from '../../global/forms/bankAccountForm';
import EditCreditCardBillingForm from './edit-creditcard-billing-component';
import EditCreditCardForm from './edit-creditcard-component';
import EditBankAccountBillingForm from './edit-bankaccount-billing-component';
import EditBankAccountForm from './edit-bankaccount-component';

import { updatePaymentMethod, updatePaymentBilling, getUserInfo } from '../actions';
import { createAccount, createCustomer, updateBankDetails, updateBillingAddress, updateCreditCardDetails } from '../../registration/actions';
import { pushSuccess } from '../../global/actions';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

function capitalizeFirstLetter(string) {
  return !string || string.length === 0 ? '' : string.charAt(0).toUpperCase() + string.slice(1);
}

class DashboardPaymentMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showcreditform: false,
      showbankform: false,
      width: window.innerWidth
    }

    this.toggleCreditForm = this.toggleCreditForm.bind(this);
    this.toggleBankForm = this.toggleBankForm.bind(this);
    this.updateCreditCardOnSubmit = this.updateCreditCardOnSubmit.bind(this);
    this.updateBankOnSubmit = this.updateBankOnSubmit.bind(this);
    this.checkCreditForm = this.checkCreditForm.bind(this);
    this.checkBankForm = this.checkBankForm.bind(this);
    this.createBlueswipeDetails = this.createBlueswipeDetails.bind(this);
    this.createBillingDetails = this.createBillingDetails.bind(this);
    this.getMandatoryUserDetails = this.getMandatoryUserDetails.bind(this);
    this.billingOnSubmit = this.billingOnSubmit.bind(this);
    this.addBankOnSubmit = this.addBankOnSubmit.bind(this);
    this.addCreditCardOnSubmit = this.addCreditCardOnSubmit.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  checkCreditForm = oldProps => {
    let oldAdmin = oldProps.dashboard;
    let { dashboard } = this.props;

    if (!oldAdmin.user || !dashboard.user)
      return;

    if (!this.state.showcreditform)
      return;

    let oldCCs = [];
    if (oldAdmin.user.creditCards)
      oldCCs = oldAdmin.user.creditCards;

    let newCCs = [];
    if (dashboard.user.creditCards)
      newCCs = dashboard.user.creditCards;

    if (oldCCs.length !== newCCs.length || (oldCCs[0] && oldCCs[0].sourceId !== newCCs[0].sourceId))
      this.setState({
        showcreditform: false
      });
  }

  checkBankForm = oldProps => {
    let oldAdmin = oldProps.dashboard;
    let { dashboard } = this.props;

    if (!oldAdmin.user || !dashboard.user)
      return;

    if (!this.state.showbankform)
      return;

    let oldBnks = [];
    if (oldAdmin.user.accounts)
      oldBnks = oldAdmin.user.accounts;

    let newBnks = [];
    if (dashboard.user.accounts)
      newBnks = dashboard.user.accounts;

    if (oldBnks.length !== newBnks.length || (oldBnks[0] && oldBnks[0].sourceId !== newBnks[0].sourceId))
      this.setState({
        showbankform: false
      });
  }

  componentDidUpdate(oldProps) {
    this.checkCreditForm(oldProps);
    this.checkBankForm(oldProps);
  }

  toggleCreditForm() {
    this.setState({
      showcreditform: !this.state.showcreditform
    })
  }

  toggleBankForm() {
    this.setState({
      showbankform: !this.state.showbankform
    })
  }

  updateCreditCardOnSubmit = (values, { setSubmitting }) => {
    let { dispatch, global } = this.props;

    const formData = {
      ...values,
      ...this.createBlueswipeDetails('customer'),
    }

    setSubmitting(true);

    dispatch(createCustomer(formData)).then(response => {
      if (!response.message)
        dispatch(updateCreditCardDetails(global.token, response.brand, response.lastFour,
          response.month, response.year, response.sourceId, false))
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      setSubmitting(false);
    })
  }

  billingOnSubmit = (values, { setSubmitting }, accountType) => {
    let { dispatch, global, dashboard } = this.props;

    setSubmitting(true);

    const user = dashboard.user;
    dispatch(updateBillingAddress(global.token, user.userType, this.createBillingDetails(values), accountType)).then(response => {
      if (!response.message) {
        dispatch(pushSuccess('Billing address updated successfully!'));
        dispatch(getUserInfo(global.userId))
      }
    }).finally(() => {
      setSubmitting(false);
    })
  }

  createBillingDetails = (values) => {
    return {
      type: values.type,
      bill_businessName: values.businessName ? values.businessName : '',
      bill_tin: values.tin ? values.tin : '',
      bill_firstName: values.firstName ? values.firstName : '',
      bill_lastName: values.lastName ? values.lastName : '',
      bill_address1: values.address && values.address.address1 ? values.address.address1 : '',
      bill_address2: values.address && values.address.address2 ? values.address.address2 : '',
      bill_zip: values.address && values.address.zip ? values.address.zip : '',
      bill_city: values.address && values.address.city ? values.address.city : '',
      bill_state: values.address && values.address.state ? values.address.state : '',
    }
  }

  getMandatoryUserDetails = () => {
    const { dashboard } = this.props;

    const user = dashboard.user;

    return {
      bill_email: user.email,
      bill_phoneNumber: user.phoneNumber,
    };
  }

  createBlueswipeDetails = (accountType) => {
    const { dashboard } = this.props;

    const user = dashboard.user;
    const billingObj = accountType === 'account' ? user.accountBilling : user.creditCardBilling;
    const userDetails = this.getMandatoryUserDetails();

    if (!billingObj)
      return userDetails;

    const billingAddress = billingObj.address;

    return {
      bill_firstName: billingObj.firstName,
      bill_lastName: billingObj.lastName,
      bill_address1: billingAddress.address1,
      bill_address2: billingAddress.address2,
      bill_city: billingAddress.city,
      bill_state: billingAddress.state,
      bill_zip: billingAddress.zip,
      ...userDetails
    }
  }

  updateBankOnSubmit = (values, { setSubmitting }) => {
    let { dispatch, dashboard, global } = this.props;

    const user = dashboard.user;

    const formData = {
      ...values,
      ...this.createBlueswipeDetails('account'),
    }
    setSubmitting(true);
    dispatch(createAccount(formData)).then(response => {
      if (!response.message)
        dispatch(updateBankDetails(global.token, user.userType, response.brand, response.accountNumber,
          values.bnk_accountNumber, response.routingNumber, response.sourceId, false))
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      setSubmitting(false);
    })
  }

  addBankOnSubmit = (values, { setSubmitting }) => {
    let { dispatch, dashboard, global } = this.props;

    const user = dashboard.user;

    const formData = {
      ...values,
      ...this.getMandatoryUserDetails(),
    }
    setSubmitting(true);
    dispatch(createAccount(formData)).then(response => {
      if (!response.message)
        dispatch(updateBankDetails(global.token, user.userType, response.brand, response.accountNumber,
          values.bnk_accountNumber, response.routingNumber, response.sourceId, false, false))
          .then(response => {
            dispatch(updateBillingAddress(global.token, user.userType, formData, 'account'))
              .then(addressResponse => {
                if (!addressResponse.message) {
                  dispatch(pushSuccess('Account Details Updated Sucessfully!'));
                  dispatch(getUserInfo(global.userId))
                }
              })
          })
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      setSubmitting(false);
    })
  }

  addCreditCardOnSubmit = (values, { setSubmitting }) => {
    let { dispatch, global, dashboard } = this.props;

    const user = dashboard.user;

    const formData = {
      ...values,
      ...this.getMandatoryUserDetails('customer'),
    }

    setSubmitting(true);

    dispatch(createCustomer(formData)).then(response => {
      if (!response.message)
        dispatch(updateCreditCardDetails(global.token, response.brand, response.lastFour,
          response.month, response.year, response.sourceId, false, false))
          .then(response => {
            dispatch(updateBillingAddress(global.token, user.userType, formData, 'customer'))
              .then(addressResponse => {
                if (!addressResponse.message) {
                  dispatch(pushSuccess('Account Details Updated Sucessfully!'));
                  dispatch(getUserInfo(global.userId))
                }
              })
          })
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      setSubmitting(false);
    })
  }

  renderEditCreditCards(ccs, isMobile, error) {
    let cardInfo;

    if (this.state.showcreditform) {
      cardInfo = (<EditCreditCardForm onSubmit={this.updateCreditCardOnSubmit} onBack={this.toggleCreditForm} isMobile={isMobile} errorMessage={error} />);
    }
    else if (ccs.length === 0) {
      cardInfo = (<div className="col-12">No Credit Cards on File.</div>)
    } else {
      cardInfo = ccs.map((cc) => {
        return (
          <div key={cc._id} className="col-12">
            <div>{capitalizeFirstLetter(cc.brand)} Card Ending In {cc.lastFour}</div>
            <div>Expires {cc.month}/{cc.year}</div>
          </div>
        )
      })
    }

    return (
      <div className="col-12 mb-3">
        <h3>Credit Card</h3>
        {<EditCreditCardBillingForm onSubmit={(values, form) => { this.billingOnSubmit(values, form, "customer") }}
          isMobile={isMobile} errorMessage={error} />}
        <h5>Card Information</h5>
        {cardInfo}
        {!this.state.showcreditform && (<button className="btn btn-primary mt-2" onClick={this.toggleCreditForm}>Replace</button>)}
      </div>
    )
  }

  renderAddCreditCards(isMobile, error) {
    return (
      <div className="col-12 mb-3">
        <h3>Credit Card</h3>
        {this.state.showcreditform
          ? (<CreditCardForm onSubmit={this.addCreditCardOnSubmit} onBack={this.toggleCreditForm} isMobile={isMobile} errorMessage={error} isMandatory />)
          : (<div className="col-12">No Credit Cards on File.</div>)
        }
        {!this.state.showcreditform && (<button className="btn btn-primary mt-2" onClick={this.toggleCreditForm}>Add</button>)}
      </div>
    )
  }

  renderEditBankAccounts(accounts, isMobile, error) {
    let bankInfo;
    if (this.state.showbankform) {
      bankInfo = (<EditBankAccountForm onSubmit={this.updateBankOnSubmit} onBack={this.toggleBankForm} isMobile={isMobile} errorMessage={error} />);
    }
    else if (!accounts || accounts.length === 0) {
      bankInfo = (<div className="col-12">No Bank Account on File.</div>)
    }
    else {
      bankInfo = accounts.map((account) => {
        return (<div key={account._id} className="col-12">
          <div>{capitalizeFirstLetter(account.brand)} Account Ending In {account.lastFour ? account.lastFour : account.accountNumber.substr(-4)}</div>
        </div>);
      });
    }

    return (
      <div className="col-12 mb-3">
        <h3>Bank Account</h3>
        {<EditBankAccountBillingForm onSubmit={(values, form) => { this.billingOnSubmit(values, form, "account") }}
          isMobile={isMobile} errorMessage={error} />}
        {bankInfo}
        {!this.state.showbankform && (<button className="btn btn-primary mt-2" onClick={this.toggleBankForm}>Replace</button>)}
      </div>
    )
  }

  renderAddBankAccounts(isMobile, error) {
    return (
      <div className="col-12 mb-3">
        <h3>Bank Account</h3>
        {this.state.showbankform
          ? (<BankAccountForm onSubmit={this.addBankOnSubmit} onBack={this.toggleBankForm} isMobile={isMobile} errorMessage={error} isMandatory />)
          : (<div className="col-12">No Bank Account on File.</div>)
        }
        {!this.state.showbankform && (<button className="btn btn-primary mt-2" onClick={this.toggleBankForm}>Add</button>)}
      </div>
    )
  }


  render() {
    let { dashboard, global } = this.props;
    let isMobile = this.state.width <= 850;
    let user = dashboard.user;
    if (!user) { return (<div>Loading...</div>) }
    let error = global.errors ? global.errors.filter(e => e.errType === 'paymentmethod')[0] : null;
    return (<div className="row payment-methods">
      {!user.creditCards.length ? this.renderAddCreditCards(isMobile, error) : this.renderEditCreditCards(user.creditCards, isMobile, error)}
      {user.userType === 'owner' && (!user.accounts.length ? this.renderAddBankAccounts(isMobile, error) : this.renderEditBankAccounts(user.accounts, isMobile, error))}
    </div>);

  }
}


export default connect(mapStateToProps)(DashboardPaymentMethods);
